<template>
  <div class="product">
    <div class="imgBox"  :height="imageHeight">
        <img :src="itemData.content.boxImg.urlData" class="el-image__inner">
    </div>
    <div class="productMenu">

            <el-menu :default-active="menuIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
              <el-menu-item  v-for="item in itemData.content.menuData" :index="item.num.content" :indexPath="item.path.content">{{item.tital.content}}</el-menu-item>
            </el-menu>

    </div>
    <div class="productContent">
      <div class="contentItem">
      <div class="contentItem1" v-for="item in itemData.content.item" v-show="item.showData">
        <div class="contentItem_1" v-if="item.type == 'box'">
          <div class="contentItem_1_1">
            {{item.content.text1.content}}
          </div>
          <div class="contentItem_1_2">
            {{item.content.text2.content}}
          </div>
          <div class="contentItem_1_3">
            <img :src="item.content.text3.content" class="contentItem_1_3_img">
          </div>

        </div>
        <div class="contentItem_2" v-if="item.type == 'boxleft'">
          <div class="contentItem_2_left">
            <div class="contentItem_2_left_1">
              {{ item.content.text1.content }}
            </div>
            <div class="contentItem_2_left_2">
              {{ item.content.text2.content }}
            </div>

          </div>
          <div class="contentItem_2_right">
            <div class="contentItem_2_right_1">
              <img :src="item.content.text3.content" class="contentItem_2_right_img">
            </div>
          </div>

        </div>
        <div class="contentItem_3" v-if="item.type == 'boxvideo'">
          <video class="contentItem_3_1" controls>
            <source :src=" item.content.text4.content"  type="video/mp4">
          </video>
        </div>
        <div class="contentItem_4" v-if="item.type == 'boxrigth'">
          <div class="contentItem_4_left">
            <div class="contentItem_4_left_1">
              <img :src=" item.content.text3.content" class="contentItem_4_left_img">
            </div>
          </div>
          <div class="contentItem_4_right">
            <div class="contentItem_4_right_11">
            <div class="contentItem_4_right_1">
              {{ item.content.text1.content}}
            </div>
            <div class="contentItem_4_right_2">
              {{ item.content.text2.content}}
            </div>
          </div>
          </div>

        </div>

      </div>
      </div>
    </div>

    <div class="homeLeave">
      <div class="leave">
        <div class="homeLeave_left">
          <div class="homeLeave_left_1">
            {{itemData.content.homeLeave.text1.content}}
          </div>
          <div class="homeLeave_left_2">
            {{itemData.content.homeLeave.text2.content}}

          </div>
          <div class="homeLeave_left_3">
            <i class="el-icon-phone homeLeave_left_3_2"></i>
            <div class="homeLeave_left_3_1">
              {{itemData.content.homeLeave.text3.content}}

            </div>
          </div>
          <div class="homeLeave_left_4">
            <i class="el-icon-message homeLeave_left_3_2"></i>
            <div class="homeLeave_left_4_1">
              {{itemData.content.homeLeave.text4.content}}
            </div>
          </div>


        </div>
        <div class="homeLeave_right">
          <div class="homeLeave_right_1">
            <el-input v-model="homeLeaveData.userName" :placeholder="itemData.content.homeLeavePlace.text1"></el-input>
          </div>
          <div class="homeLeave_right_2">
            <el-input v-model="homeLeaveData.phone" :placeholder="itemData.content.homeLeavePlace.text2"></el-input>
            <el-input v-model="homeLeaveData.wechat" :placeholder="itemData.content.homeLeavePlace.text3" style="margin-left: 5px"></el-input>

          </div>
          <div class="homeLeave_right_3">
            <el-input
              type="textarea"
              :rows="5"
              :placeholder="itemData.content.homeLeavePlace.text4"
              v-model="homeLeaveData.message">
            </el-input>
          </div>

          <div class="homeLeave_right_4">
            <button class="homeLeave_right_4_1" @click="commit">{{itemData.content.homeLeavePlace.commit}}</button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Data } from './js/product.js';
export default {
  name: "product",
  data() {
    return {
      dataAll:Data,
      itemData:{},
      imageHeight: "596px",
      screenWidth:0,
      menuIndex:"1",
      videoUrl2:"http://116.62.38.250//image/nr/jjfa/11.mp4",
      urlData:"",
      homeLeaveData:{
        userName:"",
        phone:"",
        wechat:"",
        message:""
      }
    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);
  },
  mounted() {
    let that = this;
    console.log(that.itemData);

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(itemData.type);
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        console.log(that.itemData);
        break;
      }
    }
    this.setWH();
    this.initBox();
    window.addEventListener('resize', this.setWH);


  },
  methods:{
    setWH() {
      let that = this;
      that.screenWidth = window.innerWidth;
      console.log("hh"+that.screenWidth);

      let hight = that.screenWidth /1440 *596;
      console.log("hh"+hight);
      that.imageHeight = hight + "px";
    },
    initBox(){
      let that = this;
      let path = that.urlData;

      if(path == "" || path == undefined){
        path = that.itemData.content.menuData[0].path.content;
      }

      that.menuIndex = that.itemData.content.menuData[0].num.content;
      for (let index in that.itemData.content.item){
        let itemData = that.itemData.content.item[index]
        if(path == itemData.path){
          itemData.showData = true;
        } else {
          itemData.showData =false;
        }

      }
    },
    handleSelect(index, path){
    let that = this;

          that.menuIndex =index;



      for (let indexItem in that.itemData.content.item){
        let itemData = that.itemData.content.item[indexItem];
        console.log(path)
        if(index == itemData.index){
          itemData.showData = true;
        } else {
          itemData.showData =false;
        }

      }
    },
    commit(){
      this.$axios
        .post('/acl/user/addUserMsg', {
          userName: this.homeLeaveData.userName,
          phone: this.homeLeaveData.phone,
          wechat:this.homeLeaveData.wechat,
          message:this.homeLeaveData.message
        })
        .then(successResponse => {
          if (successResponse.data.code === "200") {

            this.$notify({
              title: '成功',
              message: '提交成功',
              type: 'success'
            });
            this.homeLeaveData.userName="";
            this.homeLeaveData.phone="";
            this.homeLeaveData.wechat="";
            this.homeLeaveData.message="";
          } else {
            this.$notify.error({
              title: '失败',
              message: '提交失败，请重新提交'
            });
          }
        })
        .catch(failResponse => {
          this.$notify.error({
            title: '失败',
            message: '提交失败，请重新提交'
          });
        })
    }
  }
  ,
  beforeDestroy() {
    window.removeEventListener('resize', this.setWH); // 移除监听器
  }
}
</script>

<style scoped>
.homeLeave_right_4_1{
  font-family: SourceHanSansCN;
  width: 100%;
  background: #014ED5;
  border-radius: 24px 24px 24px 24px;
  color: #FFFFFF;
  aspect-ratio: 560/48;
  border: none !important;
}
.homeLeave_right_4{
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_3{
  height: 120px;
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_2{
  height: 40px;
  display: flex;
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right_1{
  height: 40px;
  margin-top: 24px;
  margin-left: 24px;
  margin-right: 24px;
}
.homeLeave_right{
  width: 53.5%;
  border-radius: 8px;
  /*box-shadow:*/
  /*  0 0 0 2px #a6a9ad, !* 外阴影，模拟边框 *!*/
  /*  0 2px 5px #FFFFFF;  !* 内阴影，增加元素立体感 *!*/
}
.homeLeave_left_3_2{
  font-size: 56px;
}
.homeLeave_left_4_1{
  font-family: Montserrat, Montserrat;
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 3px;
}
.homeLeave_left_4{
  margin-top: 24px;
  display: flex;
  align-items: center;
}
.homeLeave_left_3_1{
  font-family: Montserrat, Montserrat;
  font-weight: 700;
  font-size: 24px;
  color: #333333;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-left: 3px;

}
.homeLeave_left_3{
  display: flex;
  margin-top: 28px;
  align-items: center;

}
.homeLeave_left_2{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 20px;
  color: #454545;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.homeLeave_left_1{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.homeLeave_left{
  width: 46.5%;
  background-color: #FFFFFF;
}
.leave{
  width: 78%;
  display: flex;
}
.homeLeave{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  margin-top: 120px;
  margin-bottom: 120px;
}
.contentItem_4_right_11{
  width: 88%;
}
.contentItem_4_right_2{
  width: 100%;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: right;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.contentItem_4_right_1{
  width: 100%;
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: right;
  font-style: normal;
  text-transform: none;
}
.contentItem_4_right{
  width: 53.21%;
  display: flex;
  justify-content: right;
}
.contentItem_4_left_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.contentItem_4_left_1{
  width: 100%;
  padding-top: 64.89%;
  position: relative;
}
.contentItem_4_left{
  width: 46.79%;
}
.contentItem_4{
  display: flex;
}
.contentItem_3_1{
  width: 100%;
  aspect-ratio: 1120/341;

}
.contentItem_3{
  width: 100%;

}
.contentItem_2_right_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.contentItem_2_right_1{
  width: 100%;
  padding-top: 64.89%;
  position: relative;
}
.contentItem_2_right{
  width: 46.79%;
}
.contentItem_2_left_2{
  width: 88%;
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.contentItem_2_left_1{
  width: 88%;
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.contentItem_2_left{
  width: 53.21%;
}
.contentItem_2{
  display: flex;
}
.contentItem_1_3_img{
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.contentItem_1_3{
  width: 100%;
  padding-top: 30.44%;
  position: relative;
  margin-top: 40px;
}
.contentItem_1_2{
  font-family: SourceHanSansCN;
  font-weight: 400;
  font-size: 16px;
  color: #454545;
  line-height: 28px;
  text-align: justify;
  font-style: normal;
  text-transform: none;
  margin-top: 24px;
}
.contentItem_1_1{
  font-family: SourceHanSansCN;
  font-weight: 600;
  font-size: 40px;
  color: #333333;
  line-height: 56px;
  text-align: left;
  font-style: normal;
  text-transform: none;
}
.contentItem1{
  width: 100%;
  margin-top: 68px;
  /*display: flex;*/

}
.contentItem{
  width: 78%;
  /*display: flex;*/

}
.productContent{
  width: 100%;
  background-color: #FFFFFF;
  display: flex;
  justify-content: center;
  margin-top: 68px;
  margin-bottom: 10px;
}
.imgBox{
  width: 100%;
}
.product{
  background: #FFFFFF;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/product.vue